
import { useState } from 'react';

const ContactSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({ name: '', email: '', message: '' });
      
      setTimeout(() => {
        setSubmitStatus('idle');
      }, 3000);
    }, 1000);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section id="contact" className="py-20 px-6 bg-[#F5E6D3]">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1B3A52] mb-5">
          We're Here to Pray With You
        </h2>
        <p className="text-base text-gray-700 mb-10">
          Share your prayer requests with us. Your request will be kept confidential and lifted up in prayer.
        </p>

        <form onSubmit={handleSubmit} className="bg-white rounded-3xl shadow-xl p-8 md:p-10">
          <div className="space-y-5">
            <div>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Your Name"
                required
                className="w-full px-5 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-[#D4AF37] transition-colors text-sm"
              />
            </div>
            <div>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Your Email"
                required
                className="w-full px-5 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-[#D4AF37] transition-colors text-sm"
              />
            </div>
            <div>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Your Prayer Request or Message"
                required
                rows={6}
                maxLength={500}
                className="w-full px-5 py-3 border border-gray-300 rounded-xl focus:outline-none focus:border-[#D4AF37] transition-colors resize-none text-sm"
              ></textarea>
              <p className="text-xs text-gray-400 text-right mt-2">
                {formData.message.length}/500 characters
              </p>
            </div>
            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-[#1B3A52] text-white py-3 rounded-full text-base font-medium hover:bg-[#2a5270] transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
            >
              {isSubmitting ? 'Sending...' : 'Send Prayer Request'}
            </button>
            
            {submitStatus === 'success' && (
              <div className="bg-green-50 border border-green-200 text-green-800 px-5 py-3 rounded-xl text-sm">
                Thank you! Your prayer request has been received. We will be praying for you.
              </div>
            )}
          </div>
          <p className="text-xs text-gray-500 mt-5">
            Your request will be kept confidential
          </p>
        </form>

        {/* Social Media Icons */}
        <div className="flex items-center justify-center gap-5 mt-10">
          <a href="https://www.facebook.com/leavittpeakpress" target="_blank" rel="noopener noreferrer" className="w-11 h-11 rounded-xl border-2 border-[#1B3A52] flex items-center justify-center hover:bg-[#1B3A52] hover:text-white transition-all cursor-pointer">
            <i className="ri-facebook-fill text-lg"></i>
          </a>
          <a href="/contact" className="w-11 h-11 rounded-xl border-2 border-[#1B3A52] flex items-center justify-center hover:bg-[#1B3A52] hover:text-white transition-all cursor-pointer">
            <i className="ri-mail-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
